module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAS0lEQVQoFZXBsRHAQAyAMNh/aIfCtf8iyU/yk6wJB0NkTTgYIg8TYog8TIghsiYcDJE14WCIPEyIIfIwIYbImnAwRNaEgyHyk/z0AV5xKA8Kp+RmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_context_03.png
// module id = 225
// module chunks = 0